import { memoizeFunction, mergeStyleSets, useTheme } from '@fluentui/react';
import { IAppTheme } from 'common/theme/AppTheme';

import { containerHeight, containerWidth } from './Avatar.styles';

const baseline = 8;
const scrollButtonSize = baseline * 4;

const spacing = {
  lg: baseline * 2,
  md: baseline * 1.5,
  sm: baseline,
} as const;

// TODO: update when elevation tokens are defined by Design
const elevation = {
  level1: '100',
  level2: '200',
} as const;

const getStyles = memoizeFunction(({ appColors, semanticColors }: IAppTheme) =>
  mergeStyleSets({
    avatarRowWrapper: {
      display: 'flex',
      overflow: 'hidden',
      width: '100%',
      position: 'relative',
    },
    avatarWrapper: {
      scrollSnapAlign: 'start',
      height: 'auto',
      width: containerWidth,
    },
    button: {
      backgroundColor: semanticColors.bodyBackground,
      borderRadius: '100%',
      marginTop: containerHeight / 2 - scrollButtonSize,
      width: scrollButtonSize,
      height: scrollButtonSize,
      flexShrink: 0,
      zIndex: elevation.level2,
    },
    buttonWrapper: {
      position: 'absolute',
      display: 'flex',
      height: containerHeight,
      zIndex: elevation.level1,
    },
    container: {
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
    },
    blur: {
      width: containerWidth / 2,
      height: containerHeight,
      background: `linear-gradient(90deg, ${appColors?.pageBackgroundColor} 0%, ${appColors?.transparent} 100%)`,
      position: 'absolute',
    },
    leftBlur: {
      left: 0,
    },
    leftButton: {
      left: 0,
    },
    rightBlur: {
      transform: 'matrix(-1, 0, 0, 1, 0, 0)',
      right: 0,
    },
    rightButton: {
      right: 0,
    },
  })
);

export const useStyles = () => {
  const theme = useTheme();
  return getStyles(theme);
};

export const tokens = {
  shimmerStack: {
    childrenGap: spacing.lg,
  },
  shimmerInnerStack: {
    childrenGap: spacing.sm,
    padding: `${spacing.sm}px ${spacing.md}px`,
  },
};
